import { render, staticRenderFns } from "./DepartmentAnalytic.vue?vue&type=template&id=6f669ba9&scoped=true&"
import script from "./DepartmentAnalytic.vue?vue&type=script&lang=js&"
export * from "./DepartmentAnalytic.vue?vue&type=script&lang=js&"
import style0 from "./DepartmentAnalytic.vue?vue&type=style&index=0&id=6f669ba9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f669ba9",
  null
  
)

export default component.exports